export const getPlatformName = () => navigator.userAgent.match(/\((\w*);/)?.[1];
